import eventsService from '../../../Axios/services/events.service';
import usersService from "../../../Axios/services/users.service";
import { ReactComponent as ViewIcon } from '../../../assets/images/view-svgrepo-com.svg';
import { ReactComponent as FileIcon } from '../../../assets/images/file-text-svgrepo-com.svg';
import { openLink} from '../../content/Globals/globals';
import './CourseContent.scss';
import moment from "moment-timezone";
import {useEffect, useState} from "react";
moment.tz.setDefault("Asia/Jerusalem");

export const CourseContent = (props: any) => {

    const { content, course, event } = props;

    const [contentOwner, setContentOwner] = useState<any>(undefined)

    useEffect(() => {

        if (content) {
            const getContentOwner = async () => {
                try {
                    const res = await usersService.getUserByConnectId(content.content.createdBy);
                    if (res) {
                        setContentOwner(res.fullName ? res.fullName : 'Connect Admin');
                    }
                } catch (err) {
                    setContentOwner('Connect Admin');
                }
            }
            getContentOwner()
        }
    })

    const downloadCourseAttachment = async () => {
        try {
            await eventsService.downloadCourseAttachment({
                bbCourseId: course.bbCourseId,
                bbContentId: content.content.id
            }, content.content.contentHandler.file.fileName)
        } catch (err) {
            console.error(err)
        }
    }

    const handleContentClick = async () => {
        if (course) {
            await downloadCourseAttachment()
        } else if (event) {
            window.open('/content/' + content.id, '_self')?.focus();
        }
    }

    return content ? (

            <div className="ContentItemContainer">
                <div className="FacultyAndActionContainer">
                    <div className="facultyContainer">{contentOwner}</div>
                    <div className="actionContainer">

                        <div className="actionIcon" onClick={(e) => handleContentClick()}><ViewIcon /> View File</div>

                        <div className="viewIconMobile" onClick={(e) => handleContentClick()}><ViewIcon /></div>

                        <div className="actionIcon downloadMobile" onClick={(e) => openLink(content.content.media[0].azureLink, e)}><FileIcon /> Download</div>

                    </div>
                </div>
                <div className="titleContainer">
                    <div className="contentTitle">{content.title}</div>
                    <div className="dateCreated">{moment(content.content.created).format('MM/DD/YYYY') !== 'Invalid date' ? moment(content.content.created).format('MM/DD/YYYY') : null}</div>
                </div>

            </div>

    ) : null

}